import LoaderGallery from './LoaderGallery';

export default LoaderGallery;
